import { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { showBasicAlert } from "../../../core/common/useAlert";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import DeleteModal from "../../../core/modals/deleteModal";

const Department = () => {
  const signature = localStorage.getItem("signature");
  const [data, setData] = useState<any[]>([]);

  const updateUI = async () => {
    // Making all requests in parallel
    const [getDepartment] = await Promise.all([
      api.post("userService/getDepartment", { signature }),
    ]);
    // Setting the states after all data is fetched
    setData(getDepartment.data.data.data);
    setFilteredData(getDepartment.data.data.data);
    return;
  };

  useEffect(() => {
    // This will run when the component mounts
    const fetchDashboardData = async () => {
      try {
        await updateUI();
      } catch (err: any) {
        showBasicAlert(err.data.message[0].msg);
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  //Loding Start
  const [isLoading, setIsLoading] = useState(false); // state to track loading
  //loding end

  //Status Array Start
  const status = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  //Status Array End

  //Add Department Start
  var initialFormDataDepartment = {
    name: "",
    status: "",
  };
  const [formDataDepartment, setFormDataDepartment] = useState(
    initialFormDataDepartment
  );

  const handleInputChangeDepartment = (e: any) => {
    const { name, value } = e.target;
    setFormDataDepartment({ ...formDataDepartment, [name]: value });
  };

  const handleSubmitDepartment = async () => {
    // Validation logic here (e.g., required fields, file size)
    if (!formDataDepartment.name || !formDataDepartment.status) {
      showBasicAlert("Please fill all required fields.");
      return;
    }

    // Post data to API
    try {
      const signature = localStorage.getItem("signature");

      const dataToSend = {
        signature: signature,
        name: formDataDepartment.name,
        status: formDataDepartment.status.toLowerCase() === "active" ? 1 : 0,
      };
      try {
        setIsLoading(true);
        const response = await api.post(
          "userService/addDepartment",
          dataToSend
        );
        await updateUI();
        setIsLoading(false); // hide loader after response
        setFormDataDepartment(initialFormDataDepartment);
        showBasicAlert(response.data.message[0].msg);
        document.getElementById("close_add_department")?.click();
      } catch (error: any) {
        setIsLoading(false); // hide loader after response
        console.log(error);
      }
    } catch (error) {
      console.log(error);
      console.error("Error adding Tax:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };

  //Add Department End

  //Edit Departmenmt Start
  const [selectedDepartmentEdit, setSelectedDepartmentEdit] = useState<
    any | null
  >(null);
  const handleDepartmentEdit = (record: any) => {
    try {
      setSelectedDepartmentEdit(record);
    } catch (e) {
      console.log(e);
    }
  };

  const handleEditSaveChanges = async () => {
    try {
      // Prepare the payload
      const body = {
        signature: signature,
        name: selectedDepartmentEdit.Department,
        status: selectedDepartmentEdit.Status,
        id: selectedDepartmentEdit.key,
      };
      try {
        setIsLoading(true);
        const response = await api.post("userService/editDepartment", body);
        await updateUI();
        setIsLoading(false); // hide loader after response
        showBasicAlert(response.data.message[0].msg);
        document.getElementById("close_add_department_edit")?.click();
      } catch (error: any) {
        setIsLoading(false); // hide loader after response
        showBasicAlert(error.data.message[0].msg);
      }
    } catch (error) {
      console.error("Error updating company details:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };
  //Edit Department End

  //Delete Department Start
  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var department_id = deleteRecord.key;
        try {
          setIsLoading(true);
          const response = await api.post("userService/deleteDepartment", {
            signature,
            department_id,
          });
          await updateUI();
          setIsLoading(false); // hide loader after response
          showBasicAlert(response.data.message[0].msg);
        } catch (error: any) {
          setIsLoading(false); // hide loader after response
          showBasicAlert(error.data.message[0].msg);
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
      setDeleteRecord(null);
    }
  };
  //Delete Department End

  //Filter Start
  const [filteredData, setFilteredData] = useState(data);
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Ascending");

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          if (statusFilter && item.Status !== statusFilter) {
            return false;
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Ascending":
              return a.Department.localeCompare(b.Department);
            case "Descending":
              return b.Department.localeCompare(a.Department);

            default:
              return a.Department.localeCompare(b.Department);
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          showBasicAlert("No Data");
        }
      }
    }
  }, [statusFilter, sortBy]);

  //Filter End

  //Exort Data Handle function Start
  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Example columns
    const columns = ["ID", "Company Name", "Email", "Plan", "Date", "Status"];
    const tableData: (string | number)[][] = filteredData.map((item) => [
      item.key, // Assuming the first element is a number (ID)
      item.Department, // Assuming the second element is a string (Company name)
      item.NoOfEmployees, // Email (string)
      item.Status, // Status (string)
    ]);
    // Generate the table in the PDF (no need to pass `doc` as the first argument anymore)
    doc.autoTable({
      head: [columns],
      body: tableData,
    });

    // Save the PDF
    doc.save("department.pdf");
  };
  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData); // Convert JSON to sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "department.xlsx");
  };
  //Exort Data Handle function End

  const columns = [
    {
      title: "Department",
      dataIndex: "Department",
      render: (text: String, record: any) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
      sorter: (a: any, b: any) => {
        const lengthA = a.Department ? a.Department.toString().length : 0;
        const lengthB = b.Department ? b.Department.toString().length : 0;
        return lengthA - lengthB;
      },
    },
    {
      title: "No of Employees",
      dataIndex: "NoOfEmployees",
      sorter: (a: any, b: any) =>
        parseFloat(a.NoOfEmployees) - parseFloat(b.NoOfEmployees),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${
            text === "Active" ? "badge-success" : "badge-danger"
          } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text: String, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#edit_department"
            onClick={() => handleDepartmentEdit(record)}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#delete_modal"
            onClick={() => setDeleteRecord(record)}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];
  const statusChoose = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  return (
    <>
      {isLoading && <Loader />}

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Departments</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Departments
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={handleExportPDF}
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as PDF
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={handleExportExcel}
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_department"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Department
                </Link>
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Department List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Status {statusFilter}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Active")}
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Inactive")}
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By: {sortBy}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Ascending")}
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Descending")}
                      >
                        Descending
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={JSON.stringify(filteredData)}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Department */}
      <div className="modal fade" id="add_department">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Department</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Deparment Name<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formDataDepartment.name}
                        onChange={handleInputChangeDepartment}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="status"
                        value={formDataDepartment.status}
                        onChange={handleInputChangeDepartment}
                      >
                        <option value="">Select</option>
                        {status.map((data) => (
                          <option key={data.value} value={data.value}>
                            {data.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  id="close_add_department"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmitDepartment}
                >
                  Add Department
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Department */}
      {/* Edit Department */}
      <div className="modal fade" id="edit_department">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Department</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                {selectedDepartmentEdit && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Department Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedDepartmentEdit.Department || ""}
                          onChange={(e) =>
                            setSelectedDepartmentEdit((prev: any) => ({
                              ...prev,
                              Name: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Status</label>
                        <CommonSelect
                          className="select"
                          options={statusChoose}
                          defaultValue={{
                            value: selectedDepartmentEdit.Status,
                            label: selectedDepartmentEdit.Status,
                          }}
                          onChange={(selectedOption: any) =>
                            setSelectedDepartmentEdit((prev: any) => ({
                              ...prev,
                              Status: selectedOption.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  id="close_add_department_edit"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={handleEditSaveChanges}
                >
                  Save Department
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Department */}

      <DeleteModal
        modalId="delete_modal"
        onDelete={handleDelete}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
      />
    </>
  );
};

export default Department;
